import React from "react";
import "./passwordChecker.scss";

const PasswordChecker = ({ password }) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(
    password
  );
  const hasNumber = /\d/.test(password);
  const hasMinLength = password.length >= 8;
  return (
    <div
      className="password-checker-container"
      style={{
        background:
          hasUpperCase &&
          hasLowerCase &&
          hasSpecialChar &&
          hasNumber &&
          hasMinLength
            ? "#09b3091c"
            : "rgb(255 0 0 / 13%)",
        border:
          hasUpperCase &&
          hasLowerCase &&
          hasSpecialChar &&
          hasNumber &&
          hasMinLength
            ? "2px solid green"
            : "2px solid red",
      }}>
      <p style={{ marginBottom: "2px", color: "black", fontWeight: "600" }}>
        {"Password must contain the following:"}
      </p>
    {! hasUpperCase && <div>
        <span className="password-checker-icons">
          {hasUpperCase ? (
            <i style={{ color: "green" }} className="bi bi-check-lg"></i>
          ) : (
            <i style={{ color: "red" }} className="bi bi-x-lg"></i>
          )}
        </span>
        <span
          style={{ fontWeight: "600", color: hasUpperCase ? "green" : "red" }}>
          A capital (uppercase) letter
        </span>
      </div>}
      {!hasLowerCase&&<div>
        <span className="password-checker-icons">
          {hasLowerCase ? (
            <i style={{ color: "green" }} className="bi bi-check-lg"></i>
          ) : (
            <i style={{ color: "red" }} className="bi bi-x-lg"></i>
          )}
        </span>
        <span
          style={{ fontWeight: "600", color: hasLowerCase ? "green" : "red" }}>
          A lowercase letter
        </span>
      </div>}
    {!hasSpecialChar &&  <div>
        <span className="password-checker-icons">
          {hasSpecialChar ? (
            <i style={{ color: "green" }} className="bi bi-check-lg"></i>
          ) : (
            <i style={{ color: "red" }} className="bi bi-x-lg"></i>
          )}
        </span>
        <span
          style={{
            fontWeight: "600",
            color: hasSpecialChar ? "green" : "red",
          }}>
          A special character (e.g - !@#$%^&*)
        </span>
      </div>}
     {!hasNumber && <div>
        <span className="password-checker-icons">
          {hasNumber ? (
            <i style={{ color: "green" }} className="bi bi-check-lg"></i>
          ) : (
            <i style={{ color: "red" }} className="bi bi-x-lg"></i>
          )}
        </span>
        <span style={{ fontWeight: "600", color: hasNumber ? "green" : "red" }}>
          A number
        </span>
      </div>}
     {! hasMinLength &&<div>
        <span className="password-checker-icons">
          {hasMinLength ? (
            <i style={{ color: "green" }} className="bi bi-check-lg"></i>
          ) : (
            <i style={{ color: "red" }} className="bi bi-x-lg"></i>
          )}
        </span>
        <span
          style={{ fontWeight: "600", color: hasMinLength ? "green" : "red" }}>
          Minimum 8 characters
        </span>
      </div>}
    </div>
  );
};

export default PasswordChecker;
